import { motion } from "framer-motion";
import "./Benifits.css";
import coachImg from "../assets/benefit1.jpg";
import trainingImg from "../assets/benefit2.jpg";

export default function Benefits() {
  const fadeUp = {
    hidden: { opacity: 0, y: 60 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <section className="benefits">
      <motion.h2
        initial="hidden"
        whileInView="visible"
        transition={{ duration: 0.8 }}
        variants={fadeUp}
      >
        The SmashKaro Advantage
      </motion.h2>

      <div className="benefits-layout">
        {/* Floating Images */}
        <motion.img
          src={coachImg}
          alt="Small group coaching"
          className="floating-img top-left"
          initial={{ opacity: 0, x: -60, y: -60 }}
          whileInView={{ opacity: 1, x: 0, y: 0 }}
          transition={{ duration: 0.9 }}
          viewport={{ once: true }}
        />
        <motion.img
          src={trainingImg}
          alt="Footwork training"
          className="floating-img bottom-right"
          initial={{ opacity: 0, x: 60, y: 60 }}
          whileInView={{ opacity: 1, x: 0, y: 0 }}
          transition={{ duration: 0.9, delay: 0.2 }}
          viewport={{ once: true }}
        />

        {/* Center Text */}
        <div className="benefits-text">
          <motion.h3
            initial="hidden"
            whileInView="visible"
            transition={{ duration: 0.8, delay: 0.1 }}
            variants={fadeUp}
          >
            Train Smarter. Move Faster. Play Fearless.
          </motion.h3>

          <motion.p
            initial="hidden"
            whileInView="visible"
            transition={{ duration: 0.8, delay: 0.2 }}
            variants={fadeUp}
          >
            At <strong>SmashKaro</strong>, every session is crafted to make you
            sharper, quicker, and more confident on court. Our approach combines
            focused coaching with advanced tactical drills, giving you the perfect
            balance between skill and strength.
          </motion.p>

          <motion.p
            initial="hidden"
            whileInView="visible"
            transition={{ duration: 0.8, delay: 0.3 }}
            variants={fadeUp}
          >
            With <span>small group sessions</span> and <span>personalized attention</span>,
            you’ll refine your footwork, boost stamina, and master strategic positioning —
            all while having fun and staying motivated.
          </motion.p>

          <motion.p
            initial="hidden"
            whileInView="visible"
            transition={{ duration: 0.8, delay: 0.4 }}
            variants={fadeUp}
          >
            Whether you’re aiming to dominate weekend matches or compete at tournament level,
            our tailored training adapts to your goals and pace — because every player’s
            journey is unique.
          </motion.p>
        </div>
      </div>
    </section>
  );
}
